export enum PracticeEventStatus {
  DRAFT = 1,
  SCHEDULED = 2,
  IN_PROGRESS = 3,
  COMPLETED = 4,
  CANCELLED = 5
}

